import * as actionTypes from '../actions/actionTypes';

export const fetchSearchList = (data) => {
    return {
        type: actionTypes.FETCH_SEARCH_LIST,
        search: data
    }
}

export const createSearchList = (data) => {
    return {
        type: actionTypes.CREATE_SEARCH,
        search: data
    }
}

export const clearSearch = () => {
    return {
        type: actionTypes.CLEAR_SEARCH
    }
}
export const activePage = (page) => {
    return {
        type: actionTypes.ACTIVE_PAGE,
        page
    }
}